import React from 'react'
import './index.css'

export default function Loader() {
    return (
        <div style={{ width: '100%', textAlign: 'center' }}>
            <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
        </div>
    )
}